<div id="error-page" class="lg-form-container" fxLayout="column" ngcPerfectScrollbar>

    <div id="error-page-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="error-page-form" class="lg-form">

            <div class="logo-wrapper">
                <div class="logo" alt="logo"></div>
            </div>

            <div class="title">
<!--                <div class="mb-16">Sorry!</div>-->
                {{title}}
            </div>

            <div class="subtitle" *ngIf="errorCode == 401">
                {{message1}}
                <br/>{{message21}} <a [href]="supportUrl">{{supportTitle}}</a> {{message22}}
                <br/><span *ngIf="message31">{{message31}} <a [href]="supportUrl2">{{supportTitle2}}</a>.</span>
            </div>

            <div class="subtitle" *ngIf="errorCode != 401">
                Please contact <a [href]="supportUrl">Support</a> for further assistance.
            </div>

            <div *ngIf="showLoginLink" class="login" fxLayout="row" fxLayoutAlign="center center">
                <a routerLink="/">Go back to sign in</a>
            </div>
        </div>

    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>

</div>
